import { createContext } from "react";

export enum SubscriptionEnum {
  paid = "paid",
  trial = "trial",
  free = "free",
}

export type ProductStateType = {
  subscriptionType?: "paid" | "trial" | "free";
  subscriptions?: SubscriptionType[];
  isHosted?: boolean;
  useLegacyLicensing?: boolean;
};

export type SubscriptionType = {
  issuedDateTime: string;
  expirationDateTime: string;
  licenseType: string;
  status: string;
};

export const ProductContext = createContext<ProductStateType | null>(null);
